const FeatureLaunchNotification = ({
  title = '',
  description = '',
  ctaText = '',
  url = '',
  name = '',
  icon = '',
} = {}) => ({
  title: String(title),
  description: String(description),
  ctaText: String(ctaText),
  url: String(url),
  name: String(name),
  icon: String(icon),
});

export default FeatureLaunchNotification;

export type FeatureLaunchNotificationProps = ReturnType<typeof FeatureLaunchNotification>;
